import { WordLift } from "./wordlift.js";
import { useWordLiftRelatedLinks } from "./use-wordlift-related-links.js";
export {
  WordLift,
  useWordLiftRelatedLinks
};
//# sourceMappingURL=index.js.map
